import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAlRequestType = createAsyncThunk(
  "DropDowns/GetAlRequestType",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsReportStage/GetAlRequestType"
      );

      const data = response.data.result;
      console.log(data, "dataaaa");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownRequestType = createSlice({
  name: "DropDownRequestType",
  initialState: {
    DropDownRequestType: [],
    loadingDropDownRequestType: false,
    errorDropDownRequestType: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAlRequestType.pending, (state, action) => {
        state.loadingDropDownRequestType = true;
        state.DropDownRequestType = action.payload;
        state.errorDropDownRequestType = null;
      })
      .addCase(GetAlRequestType.fulfilled, (state, action) => {
        state.loadingDropDownRequestType = false;
        state.DropDownRequestType = action.payload;
      })
      .addCase(GetAlRequestType.rejected, (state, action) => {
        state.loadingDropDownRequestType = false;
        state.errorDropDownRequestType = action.payload;
      });
  },
});

export default DropDownRequestType.reducer;
